import { Component, OnInit } from '@angular/core';
import { FaqService } from './faq.service';
import { SessionStateService } from '../../../core/services/session-state.service';
import { FAQ } from './faq.model';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  panelOpenState: boolean[] = new Array();
  faqs: Map<string, Map<string, Array<string>>> = new Map();
  loadedFAQs: FAQ[] = [];
  constructor(private faqService: FaqService,
              private sessionStateService: SessionStateService) { }

  ngOnInit() {
    this.faqService.getFaq().subscribe(faqs => {
      this.faqs = faqs;
      this.loadFAQ();
    });
  }

  getFaqLang():  Map<string, Array<string>> {
    return this.faqs.get(this.sessionStateService.getLang());
  }

  loadFAQ() {
    Array.from(this.getFaqLang().keys()).forEach(question => {
      this.loadedFAQs.push(new FAQ(question , this.getFaqLang().get(question)));
    });
  }
}















// WEBPACK FOOTER //
// ./src/app/shared/components/faq/faq.component.ts